import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import * as ContractsList from './Saga/ContractsList';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,

} from '@material-ui/pickers';
import ListItemText from '@material-ui/core/ListItemText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';
// import "Components/RentMoney___/node_modules/react-datepicker/dist/react-datepicker.css";
import ja from "date-fns/locale/ja";
// import { Field, reduxForm ,InjectedFormProps} from 'redux-form';
// // import '../../Css/Table.css';

// import DatePicker from "react-datepicker";
// const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
interface Props {
  contracts_list_formData: any,
  contracts_list_rent_contracts_list: any,
  change_contracts_list_formData: any,
  search_contracts_list_rent_contracts_list: any,
  get_contracts_list_rent_contracts_list: any,
  shops: any,
}



interface State {
  reflash: any,
}


const pay_list =[
  {id:0, value:"　"},
  {id:1, value:"振込"},
  {id:2, value:"カード"},
  {id:3, value:"口座振替"}]

const headers = [
    { label: "賃貸革命", key: "bk_no_name" },
    { label: "申込日", key: "application_date_format" },
    { label: "契約日", key: "contract_date_format" },
    { label: "店舗", key: "section_name" },
    { label: "担当", key: "user_name" },
    { label: "契約者", key: "contractor_name1" },
    { label: "契約者カナ", key: "contractor_kana1" },
    { label: "物件名", key: "building_name" },
    { label: "号", key: "room_name" },
    { label: "契約金", key: "contract_money" },
    { label: "キャンセル日", key: "cancel_date_format" },
  ];

const division_list =[
    {id:1, value:"サブ"},
    {id:2, value:"管理"},
    {id:3, value:"一般"},
    {id:4, value:"業物"},
    {id:5, value:"業物折半"},
    {id:6, value:"専任"}]

class Search extends Component<Props, State> {

  constructor(props: Readonly<Props>) {
    super(props);
    this.state = {
      reflash: false,

    };
  

  }

  componentWillMount() {

    // this.props.initialize({output:true,name:"",date1:"",date2:""});//フォームに初期値を反映させる


  }

  onClear = () => {
    // alert(event.target.name)

    let contracts_list_formData = this.props.contracts_list_formData
    contracts_list_formData.chinkaku_mi = true
    contracts_list_formData.chinkaku_zumi = false
    contracts_list_formData.application_date_start = null
    contracts_list_formData.application_date_end = null
    contracts_list_formData.contract_date_start = moment().add(-3, "month").startOf('month').format("YYYY-MM-DD")
    contracts_list_formData.contract_date_end = null
    contracts_list_formData.contractor_name1 = ""
    contracts_list_formData.building_name = ""
    contracts_list_formData.cloudsign_completed_at_start = null
    contracts_list_formData.cloudsign_completed_at_end = null
    contracts_list_formData.division = [1,2]
    contracts_list_formData.payment_type = []
    contracts_list_formData.apply_payment_type = []
    contracts_list_formData.month_payment_type = []
    contracts_list_formData.cancel_date_start = null
    contracts_list_formData.cancel_date_end = null
    contracts_list_formData.cancel_only = false
    contracts_list_formData.cancel_not_only = false
    contracts_list_formData.cloudsign_completed_at = false
    contracts_list_formData.type = 0
    contracts_list_formData.section_id = -1

    this.props.change_contracts_list_formData(contracts_list_formData);
    
    this.props.get_contracts_list_rent_contracts_list()

    this.setState({ reflash: !this.state.reflash });
}

  handleChange = (event:any) => {
    // alert(event.target.name)
    console.log(event)

    let contracts_list_formData = this.props.contracts_list_formData


    if (event.target.name === "chinkaku_mi" || event.target.name === "chinkaku_zumi" || event.target.name === "cancel_not_only" || event.target.name === "cancel_only" || event.target.name === "cloudsign_completed_at" || event.target.name === "chinkaku_zumi_henkou") {
      
      if(event.target.name === "cancel_not_only" && event.target.checked == true){
        contracts_list_formData["cancel_only"] = false
      }else if(event.target.name === "cancel_only" && event.target.checked == true){
        contracts_list_formData["cancel_not_only"] = false
      }
      contracts_list_formData[event.target.name] = event.target.checked
    } else if (event.target.name === "condition_radio") {
        contracts_list_formData[event.target.name] = event.target.value;
        if (event.target.value == 0) {
          contracts_list_formData["response_date_start"] = ""
        }else if (event.target.value == 1) {
            // contracts_list_formData["response_date_start"] = moment().add(-3, "months").format("YYYY-MM-DD")
        }

    } else if (event.target.name === "jyukenyotei" || event.target.name === "condition") {

        if (event.target.checked) {
            let ary = contracts_list_formData[event.target.name] ? contracts_list_formData[event.target.name].split(",") : []
            ary.push(parseInt(event.target.value))
            ary = ary.filter(Boolean)
            contracts_list_formData[event.target.name] = ary.join(',')
        } else {
            contracts_list_formData[event.target.name] = contracts_list_formData[event.target.name].split(",").filter((item:any) => parseInt(item) != parseInt(event.target.value)).join(',')

        }
    } else {
      contracts_list_formData[event.target.name] = event.target.value;
    }


    this.props.change_contracts_list_formData(JSON.parse(JSON.stringify(contracts_list_formData)));

    this.props.search_contracts_list_rent_contracts_list()

    this.setState({ reflash: !this.state.reflash });

    
}

handleDateChange = (date:any, name:any) => {
  let contracts_list_formData = this.props.contracts_list_formData
  contracts_list_formData[name] = date
  this.props.change_contracts_list_formData(contracts_list_formData);

  if (name == "cancel_date_start" || name == "cancel_date_end") {
    this.props.search_contracts_list_rent_contracts_list()
  }else{
    this.props.get_contracts_list_rent_contracts_list()
  }

  this.setState({ reflash: !this.state.reflash });

};

handleChangeSectionId = (e:any, newValue:any) => {


  let contracts_list_formData = this.props.contracts_list_formData
  contracts_list_formData.section_id = newValue ? newValue.value : -1
  this.props.change_contracts_list_formData(contracts_list_formData);
  this.props.get_contracts_list_rent_contracts_list()

  this.setState({ reflash: !this.state.reflash });
}

handleSearchGet = (state:any) => { // DB取得するやつ
  // alert(state.target.value)
  let contracts_list_formData = this.props.contracts_list_formData

  contracts_list_formData[state.target.name] = state.target.value

  this.props.change_contracts_list_formData(contracts_list_formData);

  this.props.search_contracts_list_rent_contracts_list()
  this.setState({ reflash: !this.state.reflash });
}

  render() {

    // const { handleSubmit } = this.props;


    return (
      <div style={{width:200}}>

        <Card style={{ border: 0, boxShadow: "none", textAlign:"left"  }}>
          <CardContent style={{ padding: 5}}>
            <Button size={"small"} variant="contained" color="default" onClick={this.onClear}>条件クリア</Button>
            <Button style={{ backgroundColor: "#5cb85c", float: "right" }} size="small" variant="contained" color="primary">
              <CSVLink style={{textDecoration:"none", color:"white" }} headers={headers} filename={"契約リスト.csv"} data={this.props.contracts_list_rent_contracts_list}>CSV</CSVLink>
            </Button>
          </CardContent>

          <CardContent>
            <Chip style={{float:"right"}} label={this.props.contracts_list_rent_contracts_list ? this.props.contracts_list_rent_contracts_list.length + "件" : ""} variant="outlined" ></Chip>
          </CardContent>

          <RadioGroup row aria-label="position" name="type" onChange={this.handleSearchGet} value={parseInt(this.props.contracts_list_formData.type)} >
              <FormControlLabel style={{ width: "100%", marginBottom: 0, marginLeft: 0 }} control={<Radio value={0} style={{padding:1, margin:"2px 10px"}} />} label="すべて" />
              <FormControlLabel style={{ width: "100%", marginBottom: 0, marginLeft: 0 }} control={<Radio value={1} style={{padding:1, margin:"2px 10px"}} />} label="物件" />
              <FormControlLabel style={{ width: "100%", marginLeft: 0 }} control={<Radio value={2} style={{padding:1, margin:"2px 10px"}} />} label="P" />
          </RadioGroup>

          <CardContent style={{ paddingLeft: 5, paddingTop:10, paddingBottom:10  }}>
              <FormControl variant="outlined" fullWidth margin="dense" style={{marginTop:0, marginBottom:0}}>
                  <InputLabel id="sectionId-label">店舗</InputLabel>
                  <Select
                      labelId="sectionId-label"
                      id="section_id"
                      name="section_id"
                      value={this.props.contracts_list_formData.section_id}
                      onChange={this.handleChange}
                      // disabled={this.props.formData.id}
                      label="section_id"
                  >
                      <MenuItem key={-1} value={-1}>全店</MenuItem>
                      {/* {this.props.section_select.filter(a => a.value > 0 && a.value <=6 || a.value == 10 || a.value == 16 || a.value == 17 || a.value == 26 || a.value == 37 || a.value == 47).map(function (item, i) { */}
                      {this.props.shops.sort((a:any, b:any) => {return a.dispOrder < b.dispOrder ? -1 : 1;}).filter((a:any) => a.tenpoNo > 0 && a.tenpoNo <=6 || a.tenpoNo == 10 || a.tenpoNo == 16 || a.tenpoNo == 17 || a.tenpoNo == 26 || a.tenpoNo == 37 || a.tenpoNo == 47).map(function (item:any, i:any) {
                      return (
                          <MenuItem key={i} value={item.tenpoNo}>{item.tenpoName}</MenuItem>
                      );

                      })}

                  </Select>
              </FormControl>
          </CardContent>
          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0}}>
            <FormControl variant="outlined" fullWidth margin={"dense"} style={{marginTop:0, marginBottom:0}}>
              <InputLabel>区分</InputLabel>
              <Select
                  id="division"
                  name="division"
                  value={this.props.contracts_list_formData.division}
                  multiple
                  onChange={this.handleChange}
                  renderValue={()=>this.props.contracts_list_formData.division.length > 0 ? this.props.contracts_list_formData.division.map(function (item:any) {
                      return parseInt(item) >= 0 ? division_list.filter((a:any) => a.id === parseInt(item))[0].value : ""
                  }, this).join(',') : ""}
                  // size="small"
                  // MenuProps={MenuProps}
              >
                  {/* <MenuItem value={0}>-</MenuItem> */}
                  <MenuItem value={1}><Checkbox checked={this.props.contracts_list_formData.division.indexOf(1) > -1} /><ListItemText primary={"サブ"} /></MenuItem>
                  <MenuItem value={2}><Checkbox checked={this.props.contracts_list_formData.division.indexOf(2) > -1} /><ListItemText primary={"管理"} /></MenuItem>
                  <MenuItem value={3}><Checkbox checked={this.props.contracts_list_formData.division.indexOf(3) > -1} /><ListItemText primary={"一般"} /></MenuItem>
                  <MenuItem value={6}><Checkbox checked={this.props.contracts_list_formData.division.indexOf(6) > -1} /><ListItemText primary={"専任"} /></MenuItem>
                  <MenuItem value={4}><Checkbox checked={this.props.contracts_list_formData.division.indexOf(4) > -1} /><ListItemText primary={"業物"} /></MenuItem>
                  <MenuItem value={5}><Checkbox checked={this.props.contracts_list_formData.division.indexOf(5) > -1} /><ListItemText primary={"業物折半"} /></MenuItem>
                  
              </Select>
            </FormControl>
          </CardContent>
          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
            <TextField fullWidth
              label="契約者名"
              variant="outlined"
              onChange={this.handleChange}
              name="contractor_name1"
              value={this.props.contracts_list_formData.contractor_name1}
              margin="dense"
            />
          </CardContent>

          <CardContent style={{ paddingLeft: 5, paddingTop:0, paddingBottom:0 }}>
            <TextField fullWidth
              label="物件名"
              variant="outlined"
              onChange={this.handleChange}
              name="building_name"
              value={this.props.contracts_list_formData.building_name}
              margin="dense"
            />
          </CardContent>

          <CardContent style={{ padding: 5}}>
            <FormControlLabel control={<Checkbox checked={this.props.contracts_list_formData.cloudsign_completed_at} name="cloudsign_completed_at" onChange={this.handleChange} />} label="電子契約" />
          </CardContent>

          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja}>
          <CardContent style={{ padding: 5, marginBottom:10 }}>
          
            <TextField
              fullWidth
              label="申込日 開始"
              type="date"
              name="application_date_start"
              size="small"
              onChange={this.handleChange}
              value={moment(this.props.contracts_list_formData.application_date_start).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />

            <TextField
              fullWidth
              label="申込日 終了"
              type="date"
              name="application_date_end"
              size="small"
              onChange={this.handleChange}
              value={moment(this.props.contracts_list_formData.application_date_end).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            
            
          </CardContent>

          <CardContent style={{ padding: 5, marginBottom:10 }}>
            <TextField
              fullWidth
              label="契約日 開始"
              type="date"
              name="contract_date_start"
              size="small"
              onChange={this.handleChange}
              value={moment(this.props.contracts_list_formData.contract_date_start).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            <TextField
              fullWidth
              label="契約日 終了"
              type="date"
              name="contract_date_end"
              size="small"
              onChange={this.handleChange}
              value={moment(this.props.contracts_list_formData.contract_date_end).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            
            
          </CardContent>

          {/* <CardContent style={{ padding: 5, marginBottom:10 }}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="締結日 開始"
              style={{ float: "left", marginTop: "0" }}
              name="cloudsign_completed_at_start"
              value={this.props.formData.cloudsign_completed_at_start}
              onChange={(e)=>this.handleDateChange(e, "cloudsign_completed_at_start")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="yyyy/MM/dd(E)"
              margin="dense"
              id="date-picker-inline1"
              label="締結日 終了"
              style={{ float: "left", marginTop: "0", marginBottom:20 }}
              name="cloudsign_completed_at_end"
              value={this.props.formData.cloudsign_completed_at_end}
              onChange={(e)=>this.handleDateChange(e, "cloudsign_completed_at_end")}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              autoOk={true}
              invalidDateMessage={"日付の形式が違います"}
              InputLabelProps={{ shrink: true, }}
            />
          </CardContent> */}
{/* 
          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">支払区分</InputLabel>
              <Select
                margin="dense"
                id="payment_type"
                name="payment_type"
                value={this.props.formData.payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.formData.payment_type.length > 0 ? this.props.formData.payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={0}><Checkbox checked={this.props.formData.payment_type.indexOf(0) > -1} /><ListItemText primary={"　"} /></MenuItem>
                <MenuItem value={1}><Checkbox checked={this.props.formData.payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.formData.payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.formData.payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">支払予定区分</InputLabel>
              <Select
                margin="dense"
                id="apply_payment_type"
                name="apply_payment_type"
                value={this.props.formData.apply_payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.formData.apply_payment_type.length > 0 ? this.props.formData.apply_payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={1}><Checkbox checked={this.props.formData.apply_payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.formData.apply_payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.formData.apply_payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent>

          <CardContent style={{ padding: 5 }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel margin="dense">月々支払区分</InputLabel>
              <Select
                margin="dense"
                id="month_payment_type"
                name="month_payment_type"
                value={this.props.formData.month_payment_type}
                multiple
                onChange={this.handleChange}
                renderValue={()=>this.props.formData.month_payment_type.length > 0 ? this.props.formData.month_payment_type.map(function (item:any) {
                  return parseInt(item) > 0 ? pay_list.filter(a => a.id === parseInt(item))[0].value : ""
                }, this).join(',') : ""}

                                // MenuProps={MenuProps}
              >
                <MenuItem value={1}><Checkbox checked={this.props.formData.month_payment_type.indexOf(1) > -1} /><ListItemText primary={"振込"} /></MenuItem>
                <MenuItem value={2}><Checkbox checked={this.props.formData.month_payment_type.indexOf(2) > -1} /><ListItemText primary={"カード"} /></MenuItem>
                <MenuItem value={3}><Checkbox checked={this.props.formData.month_payment_type.indexOf(3) > -1} /><ListItemText primary={"口座振替"} /></MenuItem>
              </Select>
            </FormControl>
          </CardContent> */}

          <CardContent style={{ padding: 5, marginTop:10 }}>
            <TextField
              fullWidth
              label="キャンセル日 開始"
              type="date"
              name="cancel_date_start"
              size="small"
              onChange={this.handleChange}
              value={moment(this.props.contracts_list_formData.cancel_date_start).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            <TextField
              fullWidth
              label="キャンセル日 終了"
              type="date"
              name="cancel_date_end"
              size="small"
              onChange={this.handleChange}
              value={moment(this.props.contracts_list_formData.cancel_date_end).format("YYYY-MM-DD")}
              InputLabelProps={{
                  shrink: true,
              }}
              variant="standard"
            />
            
          </CardContent>
          <CardContent style={{ padding: 5}}>
            <FormControlLabel control={<Checkbox checked={this.props.contracts_list_formData.cancel_not_only} name="cancel_not_only" onChange={this.handleChange} />} label="キャンセルを除く" />
          </CardContent>
          <CardContent style={{ padding: 5}}>
            <FormControlLabel control={<Checkbox checked={this.props.contracts_list_formData.cancel_only} name="cancel_only" onChange={this.handleChange} />} label="キャンセルのみ" />
          </CardContent>


          
          </MuiPickersUtilsProvider>
        </Card>



      </div>
    );
  }
}




const mapStateToProps = (state: any) => {
  return {
    contracts_list_formData: state.ContractsList.contracts_list_formData,
    contracts_list_rent_contracts_list: state.ContractsList.contracts_list_rent_contracts_list,
    shops: state.masterReducer.shops,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    change_contracts_list_formData(state: any) {
      dispatch(ContractsList.change_contracts_list_formData(state))
    },
    search_contracts_list_rent_contracts_list(state: any) {
      dispatch(ContractsList.search_contracts_list_rent_contracts_list(state))
    },
    get_contracts_list_rent_contracts_list(state: any) {
      dispatch(ContractsList.get_contracts_list_rent_contracts_list(state))
  },


  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);
// const form = reduxForm({
//     form: 'formset', // a unique identifier for this form

//     //enableReinitialize: true, // initialValuesプロップが更新されると、フォームも更新されます。
// })(AccountingListSearchComponent)

// export default Form;

